import { cn } from '@/lib/utils';
import { SHORTLIST_CTA_LABEL } from '@/modules/public-shortlist/constants';
import {
  Button,
  type ButtonProps,
} from '@/modules/ui/components/button/Button';

export interface ShortlistBookCallButtonProps extends ButtonProps {
  label?: string;
}

export function ShortlistBookCallButton({
  className,
  label = SHORTLIST_CTA_LABEL,
  size = 'lg',
  ...props
}: ShortlistBookCallButtonProps) {
  return (
    <Button
      size={size}
      className={cn('rounded-full px-6', className)}
      {...props}
    >
      {label}
    </Button>
  );
}
